<template>
  <aside class="p-4 relative">
    <div class="text-left flex justify-between items-center">
      <h2 class="text-md font-bold">거래 내역</h2>
      <select class="text-md border-b" @change="changeSymbol">
        <option
          v-for="(item, index) in GT_BS_LIST"
          :key="item"
          :value="index"
          :selected="index == GT_BS_CURRENT_COIN.selectedIndex"
        >
          {{ item.name + "USDT" }}
        </option>
      </select>
    </div>

    <table class="table-auto w-full">
      <thead>
        <tr class="border-b text-gray-500">
          <th class="py-4">코인</th>
          <th>거래 기간</th>
          <th>수익(<small>USDT</small>)</th>
        </tr>
      </thead>
      <tbody class="text-sm" v-if="GT_LIST.length > 0">
        <tr v-for="(tx, txIndex) in GT_LIST" :key="txIndex" class="border-b">
          <td class="py-4 font-bold">{{ tx.symbol }}</td>
          <td class="text-xs">
            {{ dayjs(tx.updateTime).format("YYYY.MM.DD HH:mm:ss") }}
          </td>
          <td class="font-bold">
            <p
              :class="{
                'text-red-500': Number(tx.realizedPnl) > 0,
                'text-blue-500': Number(tx.realizedPnl) < 0,
              }"
            >
              {{
                Number(tx.realizedPnl) > 0
                  ? `${"+" + Number(tx.realizedPnl).toFixed(3)}`
                  : Number(tx.realizedPnl).toFixed(3)
              }}
            </p>
            <p class="text-blue-500 text-xs">
              수수료(별도) : {{ `${"-" + Number(tx.commission).toFixed(3)}` }}
              <!-- {{ Number(tx.) }} -->
            </p>
          </td>
        </tr>
      </tbody>
      <tbody class="text-sm" v-else>
        <tr class="h-[310px]">
          <td class="text-center" colspan="3">데이터가 존재하지 않습니다</td>
        </tr>
      </tbody>
    </table>
    <!-- 페이징 -->
    <div
      class="py-4 flex justify-center items-center text-sm space-x-4"
      v-if="GT_PAGE.totalElements != 0"
    >
      <button :disabled="GT_PAGE.page == 0" @click="prevPage">
        <ChevronLeftIcon class="size-5" />
      </button>
      <button
        v-for="pg in Array.from(
          {
            length:
              Math.floor(GT_PAGE.page / 3) < Math.floor(GT_PAGE.totalPage / 3)
                ? 3
                : GT_PAGE.totalPage < 3
                ? GT_PAGE.totalPage
                : GT_PAGE.totalPage - 3,
          },
          (v, i) => i + 3 * Math.floor(GT_PAGE.page / 3) + 1
        )"
        :key="pg"
        @click="changePage(pg)"
      >
        <span
          :class="{
            'font-bold': GT_PAGE.page == pg - 1,
            'text-gray-500': GT_PAGE.page != pg - 1,
          }"
          >{{ pg }}</span
        >
      </button>
      <button
        :disabled="GT_PAGE.page == GT_PAGE.totalPage - 1"
        @click="nextPage"
      >
        <ChevronRightIcon class="size-5" />
      </button>
    </div>
    <div class="loadingBg" :class="{ active: GT_IS_LOADING }">
      <VueSpinner size="40" color="white" />
    </div>
  </aside>
</template>

<script>
import dayjs from "dayjs";
import { VueSpinner } from "vue3-spinners";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/vue/20/solid";
import { storeName } from "@/global/variable";

const ts = "tradeStore";
const cs = "coreStore";

export default {
  name: "AppSidebar",
  data() {
    return {
      dayjs,
      symbol: "BTCUSDT",
      page: 0,
      pageList: [],
    };
  },
  components: {
    VueSpinner,
    ChevronRightIcon,
    ChevronLeftIcon,
  },
  computed: {
    ...mapGetters(ts, ["GT_LIST", "GT_PAGE", "GT_IS_LOADING"]),
    ...mapGetters(cs, ["GT_POSITION_TYPE"]),
    ...mapGetters(storeName.bs, ["GT_BS_CURRENT_COIN", "GT_BS_LIST"]),
  },
  watch: {
    GT_POSITION_TYPE(GT_POSITION_TYPE) {
      console.log("position change", GT_POSITION_TYPE);
      const position = GT_POSITION_TYPE;
      this.AT_GET_TRADE_HISTORY({
        symbol: this.GT_BS_CURRENT_COIN.coinNameUSDT,
        position: position.toUpperCase(),
      });
      // this.$store.dispatch(`${ts}/AT_GET_TRADE_HISTORY`, {
      //   symbol: this.symbol,
      //   position: position.toUpperCase(),
      // });
    },
    /* 거래내역 코인이 변경되었을 때 */
    GT_BS_CURRENT_COIN(newValue) {
      this.AT_GET_TRADE_HISTORY({
        symbol: newValue.coinNameUSDT,
        position: this.GT_POSITION_TYPE.toUpperCase(),
      });
    },
    /* 거래내역 페이지 변경시 */
  },
  methods: {
    ...mapActions(ts, ["AT_GET_TRADE_HISTORY"]),
    ...mapMutations(storeName.bs, ["MU_BS_SELECT"]),

    changeSymbol(event) {
      this.MU_BS_SELECT(Number(event.currentTarget.value));
    },
    changePage(_page) {
      this.AT_GET_TRADE_HISTORY({
        symbol: this.GT_BS_CURRENT_COIN.coinNameUSDT,
        position: this.GT_POSITION_TYPE.toUpperCase(),
        page: _page - 1,
      });
    },
    // changePage(_page) {
    //   this.page = _page - 1;
    // },
    prevPage() {
      this.AT_GET_TRADE_HISTORY({
        symbol: this.GT_BS_CURRENT_COIN.coinNameUSDT,
        position: this.GT_POSITION_TYPE.toUpperCase(),
        page: this.GT_PAGE.page - 1,
      });
    },
    nextPage() {
      this.AT_GET_TRADE_HISTORY({
        symbol: this.GT_BS_CURRENT_COIN.coinNameUSDT,
        position: this.GT_POSITION_TYPE.toUpperCase(),
        page: this.GT_PAGE.page + 1,
      });
    },
  },
};
</script>
<style>
.loadingBg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 310px;
  display: none;
  &.active {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000000e8;
  }
}
</style>
